<template>
  <div class="d-flex">
    <Sidebar />

    <div class="content-wrapper p-4">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h2 class="mb-0">📚 Administración de Blogs</h2>
        <button class="btn btn-success" @click="abrirNuevo">➕ Agregar nuevo blog</button>
      </div>

      <!-- Blog cards -->
      <div class="row">
        <div class="col-md-4 mb-4" v-for="blog in blogs" :key="blog.id">
          <div class="card h-100">
            <img :src="blog.imagen_url" class="card-img-top" alt="Imagen del blog" />
            <div class="card-body">
              <h5 class="card-title">{{ blog.titulo }}</h5>
              <p class="card-text text-muted">{{ blog.autor }} | {{ blog.estado }}</p>
              <!-- Mostrar un extracto del contenido HTML (recortado) -->
              <p class="card-text" v-html="extracto(blog.contenido)"></p>
              <div class="d-flex justify-content-between">
                <button class="btn btn-sm btn-warning" @click="editar(blog)">✏️ Editar</button>
                <button class="btn btn-sm btn-danger" @click="eliminar(blog.id)">🗑️ Eliminar</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div v-if="mostrarModal" class="modal-backdrop">
        <div class="modal-dialog modal-lg">
          <div class="modal-content p-4">
            <h4 class="mb-3 text-center">{{ editando ? 'Editar blog' : 'Nuevo blog' }}</h4>

            <input v-model="form.titulo" placeholder="Título" class="form-control mb-3" />
            <input v-model="form.imagen_url" placeholder="URL imagen principal" class="form-control mb-3" />
            
            <!-- Editor Quill con ref para acceder desde JS -->
            <quill-editor
              ref="quillEditor"
              v-model="form.contenido"
              :options="editorOptions"
              class="quill-editor"
            ></quill-editor>

            <input v-model="form.autor" placeholder="Autor" class="form-control mb-3" />
            <select v-model="form.estado" class="form-control mb-3">
              <option value="publicado">Publicado</option>
              <option value="borrador">Borrador</option>
            </select>
            <input v-model="categoriasInput" placeholder="Categorías (separadas por coma)" class="form-control mb-4" />

            <!-- Previsualización -->
            <h5>Previsualización:</h5>
            <div
              ref="preview"
              class="preview border p-3 mb-3"
              v-html="form.contenido"
              :key="form.contenido"
              style="min-height: 150px; overflow-y: auto;"
            ></div>

            <div class="d-flex justify-content-between">
              <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
              <button class="btn btn-primary" @click="guardar">{{ editando ? 'Actualizar' : 'Guardar' }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import axios from 'axios';
import Swal from 'sweetalert2';
import Quill from 'quill';

const icons = Quill.import('ui/icons');
icons['resizeImage'] = '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M14 10v4h-4v-4h4m1-2h-6v8h6v-8zm-2-4v1h-2v-1h2z"/></svg>';

export default {
  components: { Sidebar, quillEditor },
  data() {
    return {
      blogs: [],
      form: {
        id: null,
        titulo: '',
        contenido: '',
        imagen_url: '',
        autor: '',
        estado: 'publicado'
      },
      categoriasInput: '',
      mostrarModal: false,
      editando: false,
      editorOptions: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean'],
              ['link', 'image', 'video'],
              ['resizeImage']
            ],
            handlers: {
              image: this.imageHandler,
              resizeImage: this.resizeImageHandler
            }
          }
        }
      }
    };
  },
  mounted() {
    this.cargarBlogs();
  },
  methods: {
    cargarBlogs() {
      axios.get('http://localhost:3000/api/blogs').then(res => {
        this.blogs = res.data;
      });
    },
       guardar() {
     const payload = {
       ...this.form,
       categorias: this.categoriasInput.split(',').map(c => c.trim())
     };
   
     // Agregar fecha si es nuevo
     if (!this.editando) {
       payload.fecha_publicacion = new Date().toISOString().slice(0, 19).replace('T', ' ');
     }
   
     const peticion = this.editando
       ? axios.put(`http://localhost:3000/api/blogs/${this.form.id}`, payload)
       : axios.post('http://localhost:3000/api/blogs', payload);
   
     peticion.then(() => {
       Swal.fire(
         this.editando ? 'Editado' : 'Creado',
         `El blog ha sido ${this.editando ? 'actualizado' : 'agregado'}`,
         'success'
       );
       this.cerrarModal();
       this.cargarBlogs();
     });
   },
    eliminar(id) {
      Swal.fire({
        title: '¿Estás seguro?',
        text: '¡Esta acción no se puede deshacer!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.isConfirmed) {
          axios.delete(`http://localhost:3000/api/blogs/${id}`).then(() => {
            Swal.fire('Eliminado', 'El blog ha sido eliminado', 'success');
            this.cargarBlogs();
          });
        }
      });
    },
    editar(blog) {
  axios.get(`http://localhost:3000/api/blogs/${blog.slug}`).then(res => {
    const data = res.data;
    this.form = {
      id: data.id,
      titulo: data.titulo,
      contenido: data.contenido || '',
      imagen_url: data.imagen_url,
      autor: data.autor,
      estado: data.estado
    };
    this.categoriasInput = data.categorias ? data.categorias : '';
    this.editando = true;
    this.mostrarModal = true;

    this.$nextTick(() => {
      this.estilizarImagenesPreview();
    });
  });
},
    cerrarModal() {
      this.mostrarModal = false;
      this.editando = false;
      this.form = {
        id: null,
        titulo: '',
        contenido: '',
        imagen_url: '',
        autor: '',
        estado: 'publicado'
      };
      this.categoriasInput = '';
    },
    abrirNuevo() {
      this.cerrarModal();
      this.mostrarModal = true;
    },
    extracto(html) {
      const div = document.createElement('div');
      div.innerHTML = html || '';
      let text = div.textContent || div.innerText || '';
      return text.length > 150 ? text.substr(0, 150) + '...' : text;
    },
    imageHandler() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.click();

      input.onchange = async () => {
        const file = input.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('image', file);
        formData.append('tipo', 'blog');

        try {
          const res = await axios.post(
            'http://localhost:3000/api/upload?tipo=blog',
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
          const imageUrl = res.data.url;
          const quill = this.$refs.quillEditor.quill;
          const range = quill.getSelection();
          quill.insertEmbed(range.index, 'image', imageUrl);
        } catch (err) {
          console.error('Error subiendo imagen:', err);
          Swal.fire('Error', 'No se pudo subir la imagen', 'error');
        }
      };
    },
    resizeImageHandler() {
      const quill = this.$refs.quillEditor.quill;
      const range = quill.getSelection();
      if (!range) return alert('Selecciona una imagen primero');
      const [leaf] = quill.getLeaf(range.index);
      if (!leaf || leaf.domNode.tagName !== 'IMG')
        return alert('Selecciona una imagen primero');

      const img = leaf.domNode;
      const nuevoAncho = prompt(
        'Indica nuevo ancho de la imagen en % (ejemplo: 50)',
        img.style.width.replace('%', '') || ''
      );
      if (nuevoAncho) {
        img.style.width = nuevoAncho + '%';
        img.style.height = 'auto';
      }
    },
     estilizarImagenesPreview() {
    const previewDiv = this.$refs.preview;
    if (previewDiv) {
      const imgs = previewDiv.querySelectorAll('img');
      imgs.forEach(img => {
        img.style.maxWidth = '100%';
        img.style.height = 'auto';
      });
    }
  }
  },
  watch: {
  'form.contenido'() {
    console.log('Contenido cambiado, estilizando imágenes...');
    this.$nextTick(() => {
      this.estilizarImagenesPreview();
    });
  }
}
};
</script>
<style>

/* Botón personalizado de Quill para resize */
.ql-toolbar .ql-resizeImage {
  background-color: #007bff; /* azul visible */
  border-radius: 4px;
  padding: 4px;
}
.ql-toolbar .ql-resizeImage svg {
  fill: white;
  width: 40px;
  height: 40px;
}

.content-wrapper {
  flex-grow: 1;
  min-height: 100vh;
  margin-left: 250px; /* Compensa el ancho fijo de la Sidebar */
  padding: 2rem;
  position: relative;
  z-index: 1;
}

/* Modal */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.modal-dialog {
  background: white;
  max-width: 900px;
  width: 90%;
  border-radius: 8px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 20px;
}

/* Cards */
.card-img-top {
  height: 180px;
  object-fit: cover;
}

/* Preview */
.preview {
  background-color: #fafafa;
  border-radius: 4px;
}

/* Quill editor overrides */


.ql-resize {
  width: 28px;
  height: 28px;
  margin-left: 8px;
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: url('data:image/svg+xml;utf8,<svg fill="gray" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M14 10v4h-4v-4h4m1-2h-6v8h6v-8zm-2-4v1h-2v-1h2z"/></svg>') no-repeat center;
  background-size: 16px 16px;
  user-select: none;
}

.ql-container {
  min-height: 250px;
  margin-bottom: 1.5rem; /* espacio debajo del editor */
}

.ql-toolbar {
  margin-bottom: 0.5rem; /* separa la barra del área de texto */
}

.quill-editor {
  display: block;
  margin-bottom: 1.5rem; /* separa de Autor */
}

/* Opcional: mantener el alto mínimo */
.quill-editor .ql-container {
  min-height: 250px;
}

.preview img {
  max-width: 100% !important;
  height: auto !important;
  display: block !important;
  margin: 0 auto !important;
}

.preview img,
.quill-editor img {
  display: block !important;
  margin: 0 auto !important;
  max-width: 100% !important;
  height: auto !important;
}
</style>
